import { setGoalData } from "@/features/gridDataSlice";
import {
    setGoalEditConfig,
    setGoalModalTitle,
    setIsGoalFormSubmitted,
    updateAddGoalsModalDisplay,
} from "@/features/modalSlice";
import { usePermissionCheck } from "@/hooks/AllCustomHooks";
import { IMainContext, IValueString, SubModule, TGoal } from "@/ts/common-types";
import { mainContext } from "@/ts/constants";
import { archiveGoals, populateGoals, restoreGoals } from "@/ts/utils";
import { ICellRendererParams } from "ag-grid-community";
import { Dropdown, Menu } from "antd";
import { useContext } from "react";
import { SlOptionsVertical } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";
import { filter } from "underscore";

const GoalActionCellRenderer = (params: ICellRendererParams) => {
    const { goalsGridApi, cerbosPermissions } = useContext<IMainContext>(mainContext);

    const goalListStatusType = useSelector(
        (state: { goalListStatusType: IValueString }) => state.goalListStatusType.value
    );

    const dispatch = useDispatch();

    const removeGoalRow = (goalId: number) => {
        const rowData: TGoal[] = [];
        goalsGridApi.forEachNode((node) => rowData.push(node.data));
        goalsGridApi.setRowData(
            filter(rowData, (row) => row.goal_id !== goalId)
        );
    };

    const GOAL_ACTION_CONFIG: Record<string, Record<"updateFunc", any>> = {
        archive: {
            updateFunc: archiveGoals
        },
        restore: {
            updateFunc: restoreGoals
        }
    }

    const handleEditCloneGoal = (type: string) => {
        dispatch(setIsGoalFormSubmitted(false));
        dispatch(setGoalEditConfig(params.data));
        dispatch(updateAddGoalsModalDisplay(true));
        dispatch(setGoalModalTitle(type));
    }

    const handleArchiveRestoreGoal = async (type: string) => {
        const isActionConfirmed = window.confirm(
            `Are you sure you want to ${type} goal - ${params.data.goal_name}?`
        );

        if (isActionConfirmed) {
            await GOAL_ACTION_CONFIG[type].updateFunc(
                params.data.goal_id,
                params.data.goal_name
            );
            if (goalListStatusType !== "all") {
                removeGoalRow(params.data.goal_id);
            }
            const goalsData = await populateGoals(goalListStatusType);
            dispatch(setGoalData(goalsData));
        }
    };

    const { canEditGoal, canDeleteGoal, canCreateGoal } = usePermissionCheck();

    const goalActionMenu = (
        <Menu>
            <Menu.Item
                key="edit"
                onClick={async () =>
                    !canEditGoal ? null : handleEditCloneGoal("Edit")
                }
                disabled={!canEditGoal}
            >
                <span>Edit</span>
            </Menu.Item>
            <Menu.Item
                key="clone"
                onClick={async () => handleEditCloneGoal("Clone")}
                disabled={!canCreateGoal}
            >
                <span>Clone</span>
            </Menu.Item>
            {params.data.goal_active_status &&
                !params.data.goal_archive_status && (
                    <Menu.Item
                        key="active"
                        onClick={() =>
                            !canDeleteGoal
                                ? null
                                : handleArchiveRestoreGoal("archive")
                        }
                        disabled={!canDeleteGoal}
                    >
                        <span>Archive</span>
                    </Menu.Item>
                )}
            {!params.data.goal_active_status &&
                params.data.goal_archive_status && (
                    <Menu.Item
                        key="restore"
                        onClick={() => handleArchiveRestoreGoal("restore")}
                        disabled={!canEditGoal}
                    >
                        <span>Restore</span>
                    </Menu.Item>
                )}
        </Menu>
    );

    return (
        <>
            {params.node.rowPinned ? null : (
                <Dropdown overlay={goalActionMenu} trigger={["click"]}>
                    <SlOptionsVertical style={{ cursor: "pointer" }} />
                </Dropdown>
            )}
        </>
    );
};

export default GoalActionCellRenderer;
